<template>
  <div class="app-container">
    <el-container>
      <el-aside width="420px" class="cbox-p14">
        <div class="section-header">角色列表</div>
        <div class="search-box">
          <el-input
            v-model="searchModel.name"
            placeholder="请输入角色名称"
            clearable
            @keyup.enter.native="getRoleList(true)"
          ></el-input>
          <el-button type="success" @click="getRoleList(true)">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </div>
        <div class="button-box">
          <el-button v-auth="'role:edit'" type="primary" @click="handleAdd">新增</el-button>
        </div>

        <div class="table-main">
          <el-table
            ref="table"
            :data="tableData"
            border
            stripe
            highlight-current-row
            height="100%"
            v-loading="tableLoading"
            @current-change="handleCurrentChange"
          >
            <el-table-column prop="name" label="角色名称" align="center" width="130"></el-table-column>
            <el-table-column prop="code" label="角色编码" align="center"></el-table-column>
            <el-table-column label="是否启用" align="center">
              <template v-slot="{ row }">
                <el-tag :type="row.deleted == 0 ? 'success' : 'danger'">{{ row.deleted == 0 ? '启用' : '禁用' }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="100" align="center" fixed="right">
              <template v-slot="{ row }">
                <el-link v-auth="'role:edit'" type="primary" @click.stop="handleEdit(row)">编辑</el-link>
                <el-link v-auth="'role:delete'" type="danger" @click.stop="handleDelete(row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            :current-page="searchModel.pageNum"
            :page-size="searchModel.pageSize"
            background
            layout="total, prev, pager, next, jumper"
            :total="dataTotal"
            @current-change="onCurrentChange"
          ></el-pagination>
        </div>
      </el-aside>

      <el-main class="cbox-p14">
        <el-tabs v-show="currentRoleId" v-model="activeName">
          <el-tab-pane :label="`角色权限（${currentRoleName}）`" name="first">
            <AuthorityList :roleId="currentRoleId" />
          </el-tab-pane>
          <el-tab-pane :label="`人员列表（${currentRoleName}）`" name="second">
            <UserList :roleId="currentRoleId" :roleName="currentRoleName" />
          </el-tab-pane>
        </el-tabs>

        <el-empty v-if="!currentRoleId" description="请选择角色信息"></el-empty>
      </el-main>
    </el-container>

    <!-- 编辑弹窗 -->
    <RoleEdit :visible.sync="editVisible" :activeId="activeRowId" @refresh="getRoleList" />
  </div>
</template>

<script>
import RoleEdit from './components/RoleEdit';
import UserList from './components/UserList';
import AuthorityList from './components/AuthorityList';

import { getRoleList, deleteRole } from '@/api/user';

export default {
  components: { RoleEdit, UserList, AuthorityList },
  data() {
    return {
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        name: ''
      },
      dataTotal: 0,
      tableData: [],
      tableLoading: false,
      activeName: 'first',
      editVisible: false,
      activeRowId: null,
      currentRoleId: null,
      currentRoleName: ''
    };
  },
  computed: {},
  watch: {},
  methods: {
    async getRoleList(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;

      this.tableLoading = true;
      const { data } = await getRoleList(this.searchModel);
      this.currentRoleId = null;
      this.currentRoleName = '';
      this.tableData = data.list || [];
      this.dataTotal = data.count || 0;
      this.tableLoading = false;
    },
    handleReset() {
      this.searchModel = {
        pageNum: 1,
        pageSize: 20,
        name: ''
      };
      this.getRoleList(true);
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getRoleList();
    },
    handleAdd() {
      this.activeRowId = null;
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    handleDelete(row) {
      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteRole(row.id);

          this.getRoleList();
          this.$message.success('删除成功');
        })
        .catch(() => {});
    },
    handleCurrentChange(val) {
      if (val) {
        this.currentRoleId = val.id;
        this.currentRoleName = val.name;
      }
    }
  },
  created() {},
  mounted() {},
  activated() {
    this.getRoleList();
  }
};
</script>

<style lang="scss" scoped>
.el-container {
  height: 100%;
  overflow: visible;
}
.el-aside {
  display: flex;
  flex-direction: column;
  height: 100%;

  &.cbox-p14 {
    padding-top: 0;
  }

  .search-box {
    display: flex;
    align-items: center;

    .el-button {
      margin-left: 14px;
    }
  }
  .button-box {
    margin: 10px 0;
  }
}
.el-main {
  margin-left: 10px;
  &.cbox-p14 {
    padding-top: 0;
  }
  .el-tabs {
    height: 100%;

    ::v-deep .el-tabs__content {
      height: calc(100% - 55px);

      .el-tab-pane {
        height: 100%;
      }
    }
  }
  .el-empty {
    height: 100%;
  }
}

.section-header {
  line-height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}
</style>
